import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=36f8a5aa&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8a5aa",
  null
  
)

export default component.exports